// Auto generated file, do not manually modify!
// com.hotpads.clientappconfig.web.handler.web.ClientAppConfigWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  ClientAppConfigWebApiHandler_getAllFeatures,
  ClientAppConfigWebApiHandler_getAllFeatures_Path,
  ClientAppConfigWebApiHandler_getFeature,
  ClientAppConfigWebApiHandler_getFeature_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetAllFeaturesParams {
  appName: string;
}
interface GetFeatureParams {
  appName: string;
  featureName: string;
}

export type ClientAppConfigWebApiHandler_getAllFeatures_Options = UseQueryOptions<
  Record<string, string>,
  unknown,
  Record<string, string>,
  Array<string | GetAllFeaturesParams>
>;

const ClientAppConfigWebApiHandler_getAllFeatures_GetKey = (getParams: GetAllFeaturesParams) => [
  ClientAppConfigWebApiHandler_getAllFeatures_Path,
  getParams,
];

/**
 * Get all app configuration for an application
 */
export const useClientAppConfigWebApiHandler_getAllFeatures = (
  getParams: GetAllFeaturesParams,
  options: Omit<ClientAppConfigWebApiHandler_getAllFeatures_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ClientAppConfigWebApiHandler_getAllFeatures_GetKey(getParams),
    queryFn: () => ClientAppConfigWebApiHandler_getAllFeatures(getParams),
  });
};
useClientAppConfigWebApiHandler_getAllFeatures.getKey = ClientAppConfigWebApiHandler_getAllFeatures_GetKey;

export type ClientAppConfigWebApiHandler_getFeature_Options = UseQueryOptions<
  string,
  unknown,
  string,
  Array<string | GetFeatureParams>
>;

const ClientAppConfigWebApiHandler_getFeature_GetKey = (getParams: GetFeatureParams) => [
  ClientAppConfigWebApiHandler_getFeature_Path,
  getParams,
];

/**
 * Get app configuration feature for an application
 */
export const useClientAppConfigWebApiHandler_getFeature = (
  getParams: GetFeatureParams,
  options: Omit<ClientAppConfigWebApiHandler_getFeature_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ClientAppConfigWebApiHandler_getFeature_GetKey(getParams),
    queryFn: () => ClientAppConfigWebApiHandler_getFeature(getParams),
  });
};
useClientAppConfigWebApiHandler_getFeature.getKey = ClientAppConfigWebApiHandler_getFeature_GetKey;
